/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */
import {
	query,
	doc,
	getDoc,
	deleteDoc,
	updateDoc,
	addDoc,
	setDoc,
	onSnapshot
} from "firebase/firestore"

import BaseFirestoreRef from "@/core/js/backend/FIrebaseWrappers/ref/BaseFirestoreRef";

export default class DocRef extends BaseFirestoreRef{

	docRef


	constructor(firestore, ...paths) {
		super(firestore, ...paths)
		this.docRef = doc(firestore, ...paths)
		console.log("DocRef = ", this)
	}

	_buildQuery(){
		let queryConstraintsExecuted = this.getQueryConstraintsExecuted()
		console.log("DocRef._buildQuery = ", this.queryConstraints, ", this.paths = ", this.paths, ", this.docRef = ", this.docRef, ", queryConstraintsExecuted = ", queryConstraintsExecuted)
		return query(this.docRef, ...queryConstraintsExecuted)
	}



	async get(){
		return this._performQuery(getDoc)
	}

	async update(object){
		return this._performDocFn(updateDoc, object)
	}

	async add(object){
		return this._performDocFn(addDoc, object)
	}

	async set(object, options){
		return this._performDocFn(setDoc, object, options)
	}

	async delete(){
		return this._performDocFn(deleteDoc)
	}

	onSnapshot(callback, error, complete){
		return this._performQuery(onSnapshot, {next: callback, error: error, complete: complete})
	}



	async _performQuery(actionFn, object, options){
		let q = this._buildQuery()
		console.log("DocRef._performQuery = ", q)
		return actionFn(q, object, options)
	}

	async _performDocFn(actionFn, object, options){
		return actionFn(this.docRef, object, options)
	}

	getRef(){
		return this.docRef
	}

}
